export function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                手机吃瓜更便捷
              </h2>
              <p className="text-background-50/85 text-sm leading-relaxed max-w-md mx-auto lg:mx-0">
                打开手机浏览器输入91吃瓜在线地址，即可畅享移动端专属优化体验。随时随地刷热点、看八卦，吃瓜不再受设备限制，通勤路上、午休间隙轻松掌握最新瓜讯。
              </p>
              <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/15 rounded-full text-background-50 text-sm backdrop-blur-sm">
                  <i className="ri-smartphone-line"></i> 手机浏览器直达
                </span>
                <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/15 rounded-full text-background-50 text-sm backdrop-blur-sm">
                  <i className="ri-wifi-line"></i> 无需下载安装
                </span>
              </div>
            </div>
            <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20floating%20in%20air%20displaying%20entertainment%20news%20app%20interface%20with%20warm%20coral%20and%20amber%20gradient%20UI%2C%20glowing%20screen%20with%20trending%20topics%2C%20editorial%20flat%20vector%20style%2C%20modern%20mobile%20design%2C%20clean%20composition%2C%20soft%20shadows%2C%20premium%20feel&width=560&height=560&seq=app-section-01&orientation=squarish"
                alt="91吃瓜手机端入口"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-xl border border-background-200/70 p-8 md:p-10 text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-accent-600"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            投稿与爆料通道
          </h2>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-lg mx-auto">
            你身边有新鲜热辣的八卦猛料？欢迎通过以下方式投稿爆料。我们保护每一位爆料人的隐私安全，重大独家爆料可获得专属奖励。91吃瓜平台期待你的加入，一起让吃瓜更有料！
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
            <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-800 rounded-full text-sm font-medium">
              <i className="ri-mail-line"></i> 投稿邮箱：tips@91chigua.com
            </span>
            <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-100 text-secondary-800 rounded-full text-sm font-medium">
              <i className="ri-wechat-line"></i> 微信：91chigua_tips
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}